import { generateApiRoute } from '@klp/core/api/helpers';

const fakturaApiName = 'faktura';

export const fakturaApiRoutes = {
    list: () => generateApiRoute([fakturaApiName]),
    download: (fakturaId: string) =>
        generateApiRoute([fakturaApiName, 'download', fakturaId]),
};
